import { render, staticRenderFns } from "./QuestionWithAnswers.vue?vue&type=template&id=ea5ce77a&"
import script from "./QuestionWithAnswers.vue?vue&type=script&lang=js&"
export * from "./QuestionWithAnswers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports